import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Core components
import Link from 'components/core/Link';
import Tooltip from 'components/core/Tooltip';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Custom
import { installationDataShape } from 'constants/PropTypesShapes';
import { showPath } from 'installations/navigation';

const InstallationTooltipContent = ({ installation }) => (
  <div>
    <div className="row m-0">
      <div className="w-100 text-center">{installation.name}</div>
    </div>
    <OnlyWith
      permissions={{
        needed: permissions.pInstallation.read,
        permissionsOrContext: 'installationPermissions',
      }}
    >
      <div className="pt-2">
        <div className="box-divider-light m-0" />
        <div className="row m-0 pt-2">
          <div className="w-100 text-center">
            <LocalizedMessage id="tooltip.clickToAccess" values={{ resource: 'installation' }} />
          </div>
        </div>
      </div>
    </OnlyWith>
  </div>
);

InstallationTooltipContent.propTypes = {
  installation: installationDataShape.isRequired,
};

const InstallationLink = ({ installation }) => (
  <div className="d-flex align-items-center">
    <Tooltip
      content={<InstallationTooltipContent installation={installation} />}
      inheritStyle={false}
      className="text-truncate"
    >
      <OnlyWith
        permissions={{
          needed: permissions.pInstallation.read,
          permissionsOrContext: 'installationPermissions',
        }}
        alternativeComponent={<span>{installation.name}</span>}
      >
        <Link path={showPath(installation.id)}>{installation.name}</Link>
      </OnlyWith>
    </Tooltip>
  </div>
);

InstallationLink.propTypes = {
  installation: installationDataShape.isRequired,
};

module.exports = InstallationLink;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/main/InstallationLink.js